import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'rt-error-placeholder',
  styleUrl: 'error-placeholder.css',
  shadow: true,
})
export class ErrorPlaceholder {
  render() {
    return <Host></Host>;
  }
}
